import styled from "styled-components";
export default styled.div `
display: flex;
justify-content: center;
align-item:center;
height:120px;
width:100%;
margin:0 15px;

`